import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const AboutUsPage = () => {
  return <CMSPage pageType="about-us" />;
};

export default AboutUsPage;
